<template>
  <div
    class="character"
    @mouseover="showDescription"
    @mouseleave="hideDescription"
  >
    <CharacterDescription
      v-show="descriptionShowed"
      class="character__description"
      :character="character.character"
    />
    <CharacterPower class="character__marker" :good="gg" v-if="!friend">
      {{ power.toFixed(0) }}
    </CharacterPower>
    <CharacterPower class="character__marker" :good="gg" v-else>
      {{ friendPower }}
    </CharacterPower>
    <div class="character__character">
      <Animation :animation="character.character" />
    </div>
    <slot />
  </div>
</template>

<script>
import gsap from "gsap";
import Animation from "./Animation";
import CharacterPower from "./CharacterPower";
import CharacterDescription from "./CharacterDescription";
import { mapState } from "vuex";

export default {
  components: { Animation, CharacterPower, CharacterDescription },
  props: {
    character: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      power: this.character.power,
      descriptionShowed: false
    };
  },
  computed: {
    ...mapState(["isMobile"]),
    friend() {
      return this.character.character === "littlebigplanet";
    },
    charPower() {
      return this.character.power.toFixed(0);
    },
    gg() {
      return this.character.character === "gg";
    },
    friendPower() {
      if (this.character.character === "littlebigplanet") {
        return "x2";
      }

      return 0;
    }
  },
  watch: {
    charPower: function(newValue) {
      gsap.to(this.$data, { duration: 0.5, power: newValue });
    }
  },
  methods: {
    showDescription() {
      if (this.isMobile) return;

      this.descriptionShowed = true;
    },
    hideDescription() {
      this.descriptionShowed = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.character {
  height: 100%;
  position: relative;

  width: 60%;

  &__character {
    height: 100%;
  }

  &__marker {
    z-index: 1;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, -110%);
  }

  &__description {
    z-index: 2;
    position: absolute;
    bottom: 90%;
    left: 50%;
    transform: translateX(-50%);

    pointer-events: none;
  }
}
</style>
